
import { Mixins, Component } from "vue-property-decorator";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';
import ReportConfigDialog from './component/reportConfigDialog.vue';

// 报告配置相关API
import { reportDisplayList } from "@/api/userDetection";

@Component({ name: 'prescription-db-reportConfig', components: { ETable, ReportConfigDialog } })
export default class ReportConfig extends Mixins(loading, Resize) {
    // 从路由获取品牌方名称和ID
    brandName = (this.$route.query.brandName as string) || "";
    merchantId = (this.$route.query.merchantId as string) || "";

    // 表格列配置
    columns = [
        { prop: "diagnosesType", label: "ID", minWidth: "80" },
        { prop: "configName", label: "报告类型", minWidth: "150" },
        { prop: "modifiedBy", label: "操作人", minWidth: "120" },
        { prop: "modifiedTime", label: "最后操作时间", minWidth: "180" },
        { prop: "action", label: "操作", minWidth: "180", fixed: "right" },
    ];

    tableData: any[] = [];

    // 弹窗相关
    dialogVisible = false;
    currentDiagnosesType: number | string = "";

    mounted() {
        this.getData();
        this.windowResize(200);
    }

    /**
     * 获取列表数据（不分页）
     */
    getData() {
        if (!this.merchantId) return;
        this.showLoading();
        reportDisplayList({
            merchantId: this.merchantId,
        }).then((res: any) => {
            this.tableData = res.data || [];
        }).finally(() => {
            this.hideLoading();
        });
    }

    /**
     * 打开编辑弹窗
     */
    handleEdit(row: any) {
        this.currentDiagnosesType = row.diagnosesType;
        this.dialogVisible = true;
    }

    /**
     * 保存成功回调
     */
    handleSaveSuccess() {
        this.getData();
    }

    /**
     * 跳转到综合建议配置页面
     */
    goTongueReportConfig(row: any) {
        this.$router.push({
            path: "/tongueReportConfig",
            query: {
                merchantId: this.merchantId,
                brandName: this.brandName,
            }
        });
    }

    /**
     * 表头样式（居中）
     */
    headerCellStyle() {
        return { background: '#F8F9FA', color: '#1A1A1C', textAlign: 'center' }
    }

    /**
     * 单元格样式（居中）
     */
    cellStyle() {
        return { textAlign: 'center' }
    }
}
